import { Schema } from "mongoose"
import { z } from "zod"


export const ZRBTenant = z.object({
  tenantId: z.string(),
  parentTenantId: z.string().optional(),
  name: z.string().optional(),
})

export type IRBTenant = z.infer<typeof ZRBTenant>;

export const RBTenantSchema: Schema = new Schema({
  tenantId: { type: String, required: true, unique: true, index: true },
  parentTenantId: { type: String },
  name: { type: String },
})
